import { VIMEO_OEMBED_URL } from '../../../../../constants';

const addExtraParamsToUrl = (url, queryParams = {}) => {
  const paramsWithValues = {};
  Object.keys(queryParams).forEach(key => {
    if (queryParams[key]) {
      paramsWithValues[key] = queryParams[key];
    }
  });
  const parsedParams = new URLSearchParams(paramsWithValues);
  const stringParams = parsedParams.toString();
  return `${VIMEO_OEMBED_URL}?url=${url}${stringParams ? `&${stringParams}` : ''}`;
};

export default addExtraParamsToUrl;
